// extracted by mini-css-extract-plugin
export var label = "_jr-2";
export var slideContainer = "_jr-0";
export var slider = "_jr-1";